import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Aruba: Country = {
    identifier: "Aruba",
    name: "Aruba",
    countryCode: "AW",
    group: CountryGroup.NORTH_AMERICA,
    isUNMember: false,
    flag: "🇦🇼",
    svgPath: "m 278.72375,427.9294 0.01,0.083 -0.13,-0.045 -0.174,-0.177 -0.174,-0.133 0.043,-0.143 0.044,-0.048 0.174,0.133 0.172,0.249 z",
}
